// @flow
type Props = {
  className?: string,
  fill?: ?string,
};

export const ScallopedWindowDevice = ({
  className,
  fill = "#0A4254",
}: Props) => {
  return (
    <svg
      viewBox="0 0 451 291"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      className={className}
    >
      <g id="Page-2" stroke={fill} strokeWidth="2">
        <path
          d="M4.07528634,255.483522 C6.68621913,258.094833 10.2278922,259.561098 13.9203083,259.559397 C13.9203083,268.23617 20.9532042,275.270084 29.6287209,275.270084 L30.0645316,275.270084 L30.0645316,275.270084 C32.3397199,283.135042 43.7605241,291 57.5334244,291 L0,291 L0,245.637075 C0,249.330025 1.46435354,252.872211 4.07528634,255.483522 Z M451,245.637075 L451,291 L393.466576,291 C407.239476,291 418.653871,283.135042 420.935468,275.270084 L421.371279,275.270084 L421.371279,275.270084 C430.046796,275.270084 437.079692,268.23617 437.079692,259.559397 C440.772108,259.561098 444.313781,258.094833 446.924714,255.483522 C449.535646,252.872211 451,249.330025 451,245.637075 Z M451,45.3629253 C451,41.6699746 449.535646,38.1277888 446.924714,35.516478 C444.313781,32.9051673 440.772108,31.4389018 437.079692,31.4406032 C437.079692,22.7638305 430.046796,15.7299165 421.371279,15.7299165 L420.935468,15.7299165 L420.935468,15.7299165 C418.653871,7.86495823 407.239476,0 393.466576,0 L451,0 L451,45.3629253 Z M0,0 L57.5398334,0 C43.7669331,0 32.3461289,7.86495823 30.0709406,15.7299165 L29.6351299,15.7299165 L29.6351299,15.7299165 C20.9596132,15.7299165 13.9267173,22.7638305 13.9267173,31.4406032 C10.2337121,31.4389027 6.69138086,32.9049638 4.07943062,35.51609 C1.46748037,38.1272162 0,41.6693851 0,45.3629253 L0,0 Z"
          fill={fill}
        ></path>
      </g>
    </svg>
  );
};
